import { filter } from './../budgetimport/budgetimport.model';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import {
  DataStateChangeEventArgs,
  GridComponent,
  PageSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import {
  employeeOnboardBO,
  PageNavigateBo,
} from "../employee-agreement/employee-agreement.model";
import { EmployeeAgreementService } from "../employee-agreement/employee-agreement.service";
import { employeeAgreementlistGridService } from "./employee-agreementlist-grid.service";
import {
  EmployeeAgreementDocumentAgencyBO,
  EmployeeDocumentBO,
  EmployeeOfficeNotesBO,
  employeeOnboardEmit,
  PayNoticePayrateDetailBO,
  RelationshipDisclosureTaxDetailBO,
} from "./employee-agreementlist.model";
import { EmployeeAgreementlistService } from "./employee-agreementlist.service";
import { ToastrService } from "ngx-toastr";
import { BackgroundStudyAuthorizationBO, DswBackgroundStudyInfoFormBO, EmployeeAgreementAndDirectDepositBO, EmployeeAgreementBO, EmployeeApplicationCoverBO, EmployeesWithholdingCertificateBO, EmploymentEligibilityVerificationBO, IndividualDirectSupportWorkerEnrollmentApplicationBO, IndividualSupportWorkerProviderAgreementBO, PayNoticeBO, RelationshipDisclosureBO, W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO, W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO } from "../employee-agreement/document/document.model";
import { FormControl, FormGroup } from "@angular/forms";
import { DateService } from "src/app/date.service";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { EmployeeService } from "../employee/employee.service";
import { functionpermission } from '../employee/employee.model';

@Component({
  selector: "app-employee-agreementlist",
  templateUrl: "./employee-agreementlist.component.html",
  styleUrls: ["./employee-agreementlist.component.scss"],
})
export class EmployeeAgreementlistComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  agreementBo: EmployeeAgreementBO = new EmployeeAgreementBO();
  backgroundBo: BackgroundStudyAuthorizationBO =
    new BackgroundStudyAuthorizationBO();
  employeeAgreementBo: EmployeeAgreementAndDirectDepositBO =
    new EmployeeAgreementAndDirectDepositBO();
  employeeApplicationBo: EmployeeApplicationCoverBO =
    new EmployeeApplicationCoverBO();
  employeesWithholdingBo: EmployeesWithholdingCertificateBO =
    new EmployeesWithholdingCertificateBO();
  employmentEligibilityBo: EmploymentEligibilityVerificationBO =
    new EmploymentEligibilityVerificationBO();
  individualDirectSupportBo: IndividualDirectSupportWorkerEnrollmentApplicationBO =
    new IndividualDirectSupportWorkerEnrollmentApplicationBO();
  individualSupportWorkerBo: IndividualSupportWorkerProviderAgreementBO =
    new IndividualSupportWorkerProviderAgreementBO();
  payNoticeBo: PayNoticeBO = new PayNoticeBO();
  relationshipBo: RelationshipDisclosureBO = new RelationshipDisclosureBO();
  w4MinnesotaWithholdingBo: W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO =
    new W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO();
  w4MNInstructionsBo: W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO =
    new W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO();

  DSwstudyBo: DswBackgroundStudyInfoFormBO[] = [];

  @Input() agreementemitBo: employeeOnboardEmit = new employeeOnboardEmit();
  @Output() dataEmitFromemployee = new EventEmitter<employeeOnboardEmit>();
  employeeBO: employeeOnboardBO = new employeeOnboardBO();
  completeStatusLid: any;
  employerStatus: any;
  employeeStatus: any;
  open_agreement = false;
  PageViewCreateOrEdit = new PageNavigateBo();
  agreementgetpotal = new EmployeeDocumentBO();
  public agreementData: Observable<DataStateChangeEventArgs>;
  templateid: any;
  clientlist: any;
  clientid: string;
  employeeOfficeNotesBo: EmployeeOfficeNotesBO = new EmployeeOfficeNotesBO();
  @ViewChild("grid") public grid: GridComponent;
  agreementlistBo = new EmployeeAgreementDocumentAgencyBO();
  getloginUser:any
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public initialPage: PageSettingsModel;
  public gridPurchase: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public formatDateOptions: object;
  Section1Form: FormGroup
  Section2Form: FormGroup
  dateForm:FormGroup;
  clientsign0: any;
  clientsign2:any;
  clientsign: string = "";
  clientsign1: string = "";
  employeesign3: any;
  employeesign2: any;
  employeesign = "";
  individualDirectSupportBoRadio1:string;
  individualDirectSupportBoRadio2:string;
  individualDirectSupportBoRadio3:string;
  individualsign = "";
  translatorsign = "";
  authorizedsign = "";
  stateList: any = [];
  appsign1: any;
  sign4: string = "";
  payratelist: any;
  Gurdsign3: string = "";
  Gurdsign: string = "";
  reationshipname:any;
  DSwstudyBolist = [];
  repsign = "";
  employerList: any;
  authorizedrepsign = "";
  relationshiplist: any;
  prepopulatevalue: any;
  prepopulateClientvalue: any;
  section1radio:any;
  genderlist: any;
  spouse:any;
  AggrementDeleteId:any
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };

  constructor(
    public global: GlobalComponent,
    public employeeService: EmployeeService,
    private agreementemitservice: EmployeeAgreementService,
    public agreementlistservice: EmployeeAgreementlistService,
    public agreementlistGridservice: employeeAgreementlistGridService,
    public toastService: ToastrService,
    public datepipe: DatePipe,
    public dateservice: DateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.agreementData=this.agreementlistGridservice
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.global.checkforlogout();
    }else{
      this.global.checkforonBoardLogout();
    }

    this.Section1Form = new FormGroup({
      
      input1: new FormControl(''),
      input2:new FormControl(''),
      input3:new FormControl(''),
      input4:new FormControl(''),
      input5:new FormControl(''),
      input6:new FormControl(''),
      input7: new FormControl(''),
      input8: new FormControl('')
  }),
  this.Section2Form = new FormGroup({
    input1: new FormControl(''),
    input2:new FormControl(''),
    input3:new FormControl(''),
   
}),
this.dateForm=new FormGroup({
  signDate1:new FormControl(''),
  signDate2:new FormControl(''),
  signDate3:new FormControl(''),
  signDate4:new FormControl(''),
  signDate5:new FormControl(''),
  signDate6:new FormControl(''),
  signDate7:new FormControl(''),
  signDate8:new FormControl(''),
  signDate9:new FormControl(''),
  signDate10:new FormControl(''),
  signDate11:new FormControl(''),
  signDate12:new FormControl(''),
  signDate13:new FormControl(''),
  signDate14:new FormControl(''),
  signDate15:new FormControl('')

})

  }
fp:functionpermission=new functionpermission()
  ngOnInit(): void {
this.getcompletedStatuusList();
    if (!this.employeeBO.edit) {
      this.agreementemitBo.employeeToDocument = true;
    }
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.getClientforDoc();
    }
    this.getDocumentStatuusList();
    this.getagreementGridData();

    this.getloginUser= localStorage.getItem("CFSS_OnboardLoginType")
    this.filterSettings = { type: "Menu" };
    this.formatDateOptions = { type: "datetime", format: "MM/dd/yyyy" };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.getpermission();
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.agreementlistservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  getEmployerType() {
    let params = new URLSearchParams();
    params.append("ListCode", "EMPLOYERTITLE");
    this.employeeService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.employerList = data;
        
      });
  }
  GetEmployeeOnboardList(data) {}

  clickAdd() {
    this.employeeBO.edit = true;
    this.employeeBO.add = true;
    this.employeeBO.addnew = true;
    this.employeeBO.print = false;
    this.employeeBO.clientid = this.clientid;
    this.employeeBO.employeeid = this.agreementemitBo.employeeId;
    this.employeeBO.agreementId = "00000000-0000-0000-0000-000000000000";
    this.employeeBO.templateId = this.templateid;
    this.employeeBO.employeestatus = null;
    this.employeeBO.employerstatus = null;
  }

  editpage(data,type) {
    if(type=="edit"){
      this.employeeBO.edit = true;
      this.employeeBO.print = false;
      this.employeeBO.addnew = false;
    }
    else if(type=="print"){
      this.employeeBO.edit = false;
      this.employeeBO.addnew = false;
      this.employeeBO.print = true;
    }
   
   
    this.employeeBO.statusinfo = data.onboardStatusLidName;
    this.PageViewCreateOrEdit.enableDoc = true;
    this.employeeBO.agreementId = data.id;
    this.employeeBO.clientid = data.employerId;
    this.employeeBO.employeeid = (this.agreementemitBo.employeeId!=null && this.agreementemitBo.employeeId!=undefined && this.agreementemitBo.employeeId!='')?this.agreementemitBo.employeeId: data.employeeId;
    this.employeeBO.iscompleted=data.isCompleted
    this.employeeBO.employeestatus = data.employeestatus;
    this.employeeBO.employerstatus = data.employerstatus;
    this.employeeBO.statusLid= data.statusLid;
   
    this.GetEmployeePayrateList(data)
  }
  PayNoticePayrateDetailBo:PayNoticePayrateDetailBO[]=[];
  GetEmployeePayrateList(data) {
    let params = new URLSearchParams();
    params.append("EmployeeId", data.employeeid);
    params.append("ClientId", data.employerId);

    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementemitservice
      .GetEmployeePayrate(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.payratelist = JSON.parse(data);      

         let obj =new  PayNoticePayrateDetailBO()



         if(this.payratelist!=undefined && this.payratelist!=null){
          this.payratelist.forEach((ele)=>{
           obj = new  PayNoticePayrateDetailBO()
           obj.rate= ele.rate;
           obj.effectiveDate=ele.startDate
           obj.service=ele.serviceName
           obj.payNoticeId=ele.id

     this.PayNoticePayrateDetailBo.push(obj)

          })}
        }
      });
    }
    else{
      this.getEmployeeDetails(data);
      this.agreementemitservice
      .GetEmployeePayratePortal()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.payratelist = JSON.parse(data);    
      }
      )
    }
  }

  backToDoc() {
    this.dataEmitFromemployee.emit(this.agreementemitBo);
    this.agreementemitBo.employeeToDocument = false;
  }

  openAgreement() {
    this.open_agreement = true;
    this.global.employeetoAgreementEmit = true;
    document.getElementById("clientdropdownmodalOpen").click();
    this.clickAdd();
  }
  EditAgreement(data,type) {
    this.open_agreement = true;
    this.global.employeetoAgreementEmit = true;
    this.editpage(data,type);
  }

  FilterAgreementEmpData() {
    this.getagreementGridData();
  }

  dataEmitFromOnboard(value) {
    this.employeeBO.edit = false;
    this.getagreementGridData();
  }

  getClientforDoc() {
    this.clientid = "";
    this.templateid=null;
    let params = new URLSearchParams();
    params.append("EmployeeId", this.agreementemitBo.employeeId);
    this.agreementlistservice
      .getClientIdlist(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.clientlist = data;
        this.getTemplatedataList();
      });
  }
  statuslist: any;
  getDocumentStatuusList() {
    let params = new URLSearchParams();
    params.append("ListCode", "DOCUMENTSTATUS");
    this.agreementlistservice
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statuslist = data;
        this.statuslist.push({
          id: "00000000-0000-0000-0000-000000000000",
          lovName: "All",
        });
        this.agreementlistBo.employerstatusLid = this.statuslist?.filter(s => s.lovName == "All")[0].id;
        this.agreementlistBo.employeestatusLid = this.statuslist?.filter(s => s.lovName == "All")[0].id;
      });
    

 
  }

  getagreementGridData() {
    let getlogin= localStorage.getItem("CFSS_OnboardLoginType")
    //  this.agreementlistBo.agencyId=this.global.globalAgencyId
    if (this.global.OnboardingLoginType != "onboardLogin") {      
      this.agreementlistBo.employeeid = this.agreementemitBo.employeeId;
      this.agreementlistGridservice.exceuteAgreementEmployee(
        this.agreementlistBo
      );
      this.agreementData.pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {},
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
    }
    else if (getlogin=="CLIENT") {
      this.agreementgetpotal.field="employerName"
      this.agreementlistGridservice.exceuteAgreementClientportal(
        this.agreementgetpotal
      );
      this.agreementData.pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {},
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
    }
    // (this.global.isClientOnboard!=true)
    else if(getlogin=="EMPLOYEE") {
      this.agreementgetpotal.field="employeeName"
      this.agreementlistGridservice.exceuteAgreementEmployeePortal(
        this.agreementgetpotal
      );
      this.agreementData.pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {},
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
    }
  }
  isCompleted:any
  filterChange() {
   
   if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementlistBo.employeeid = this.agreementemitBo.employeeId;
    this.agreementlistGridservice.exceuteAgreementEmployee(
      this.agreementlistBo
    );
    this.agreementData
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {});
    }
   else if (this.getloginUser=="CLIENT"){
    this.agreementgetpotal.completed= this.agreementlistBo.completed
    this.agreementgetpotal.status=this.agreementlistBo.employerstatusLid
    this.getagreementGridData()
   }
   else{
    this.agreementgetpotal.completed= this.agreementlistBo.completed
    this.agreementgetpotal.status=this.agreementlistBo.employeestatusLid
    this.getagreementGridData()
   }

  
  }

 

  templateList: any;
  getTemplatedataList() {
    this.agreementlistservice
      .getTemplatelist()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          if (data) {
            this.templateList = data;
          }
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  officenoteId: string;
  getOfficeNotes(data) {
    this.officenoteId = data.id;
    this.employeeOfficeNotesBo.officenotes=data.officeNotes;
  }
  clearFields(){
    this.employeeOfficeNotesBo.officenotes='';
  }

  SaveOfficeNotes() {
    this.employeeOfficeNotesBo.documentLid = this.officenoteId;
    this.agreementlistservice
      .saveOfficeNotes(this.employeeOfficeNotesBo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastService.success("Office Notes saved Successfully!");
          document.getElementById("openOfficeNotes").click();
          this.getagreementGridData()
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error.Request, "error");
        }
      );
  }

  Refresh() {
    this.agreementlistBo = new EmployeeAgreementDocumentAgencyBO()
    this.agreementlistBo.employerstatusLid = this.statuslist?.filter(s => s.lovName == "All")[0].id;
    this.agreementlistBo.employeestatusLid = this.statuslist?.filter(s => s.lovName == "All")[0].id;
    this.agreementlistBo.completed = this.completedlist?.filter(s => s.lovName == "All")[0].id;
    this.getagreementGridData();

  }


  //////////////////////////// LOV DROPDOWN ///////////////////////////////////

  completedlist: any
  getcompletedStatuusList() {
    let params = new URLSearchParams();
    params.append("ListCode", "COMPLETED");
    this.agreementlistservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.completedlist = data;
      this.completedlist.push({ id: '00000000-0000-0000-0000-000000000000', lovName: "All" });
      this.agreementlistBo.completed = this.completedlist?.filter(s => s.lovName == "All")[0].id;

      
    })
  }

  public onActionComplete(G) {
    this.agreementlistBo.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.agreementlistBo.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.agreementlistBo.type = G.columnType;
    }
  }
documentType=""
  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();
    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.agreementlistBo.orderColumn = state.sorted[0].name;
        this.agreementlistBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.agreementlistBo.field = state.action.currentFilterObject.field;
      this.agreementlistBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.agreementlistBo.operator = state.action.currentFilterObject.operator;
      this.agreementlistBo.value = state.action.currentFilterObject.value;
      this.agreementlistBo.orderColumn =
        state.action.currentFilterObject.orderColumn;
    } else {
      if (
        this.documentType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.agreementlistBo.field = "clientName";
        this.agreementlistBo.matchCase = false;
        this.agreementlistBo.operator = "startswith";
        this.agreementlistBo.value = "";
        this.agreementlistBo.orderColumn = "clientName";
      }
    }
    this.getagreementGridData();
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == "date1") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.dob = val1;
        }
      }
      if (name == "date2") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }
      if (name == "date3") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }
      if (name == "date4") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }
      if (name == "date5") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }
      if (name == "date6") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }
      if (name == "date7") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.applicantSignatureDate = val1;
        }
      }
      if (name == "date8") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.parentSignatureDate = val1;
        }
      }
      if (name == "date9") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.payNoticeBo.employeeSignDate = val1;
        }
      }
      if (name == "date10") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.payNoticeBo.employerSignDate = val1;
        }
      }
      if (name == "date11") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.dob = val1;
        }
      }
      if (name == "date12") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.applicantSignDate = val1;
        }
      }
      if (name == "date13") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.employersSignDate = val1;
        }
      }
      if (name == "date14") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.previousEmployementEndDate = val1;
        }
      }
      if (name == "date15") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.dob = val1;
        }
      }
      if (name == "date16") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.optionalTrainingCompletionDate = val1;
        }
      }
      if (name == "date17") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.optionalTrainingExpirationDate = val1;
        }
      }
      if (name == "date18") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.dob = val1;
        }
      }
      if (name == "date19") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.alien_Registration_ExpiryDate = val1;
        }
      }
      if (name == "date20") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.todaysDate = val1;
        }
      }
      if (name == "date21") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }
      if (name == "date22") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate = val1;
        }
      }
      if (name == "date23") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate1 = val1;
        }
      }

      if (name == "date24") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate2 = val1;
        }
      }
      if (name == "date25") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate3 = val1;
        }
      }
      if (name == "date26") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate4 = val1;
        }
      }
      if (name == "date27") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.employeesFirstdayEmployment = val1;
        }
      }
      if (name == "date28") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.employerSignDate1 = val1;
        }
      }
      if (name == "date29") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.reverificationDate = val1;
        }
      }
      if (name == "date30") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.documentExpiryDate = val1;
        }
      }
      // if (name == "date31") {
      //   let val = this.dateservice.inputFeildchange(event);
      //   if (val != undefined) {
      //     let val1 = this.dateservice.inputFeildchange(event);
      //     this.employmentEligibilityBo.employerSignDate3 = val1;
      //   }
      // }
      if (name == "date32") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employeesWithholdingBo.signDate = val1;
        }
      }
      if (name == "date33") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employeesWithholdingBo.firstDateOfEmployeement = val1;
        }
      }
      if (name == "date34") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.w4MinnesotaWithholdingBo.date = val1;
        }
      }
      if (name == "date35") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualSupportWorkerBo.signDate = val1;
        }
      }
      if (name == "date36") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.signDate = val1;
        }
      }
    
    }
    if (type == "datechanged") {
      if (name == "date1") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.dob = val1;
        }
      }
      if (name == "date2") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }
      if (name == "date3") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }

      if (name == "date4") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }
      if (name == "date5") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }
      if (name == "date6") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }
      if (name == "date7") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.applicantSignatureDate = val1;
        }
      }
      if (name == "date8") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.parentSignatureDate = val1;
        }
      }
      if (name == "date9") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.payNoticeBo.employeeSignDate = val1;
        }
      }
      if (name == "date10") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.payNoticeBo.employerSignDate = val1;
        }
      }
      if (name == "date11") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.dob = val1;
        }
      }
      if (name == "date12") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.applicantSignDate = val1;
        }
      }
      if (name == "date13") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.employersSignDate = val1;
        }
      }
      if (name == "date14") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.previousEmployementEndDate = val1;
        }
      }
      if (name == "date15") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.dob = val1;
        }
      }
      if (name == "date16") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.optionalTrainingCompletionDate = val1;
        }
      }
      if (name == "date17") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.optionalTrainingExpirationDate = val1;
        }
      }
      if (name == "date18") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.dob = val1;
        }
      }
      if (name == "date19") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.alien_Registration_ExpiryDate = val1;
        }
      }
      if (name == "date20") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.todaysDate = val1;
        }
      }
      if (name == "date21") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }
      if (name == "date22") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate = val1;
        }
      }
      if (name == "date23") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate1 = val1;
        }
      }
      if (name == "date24") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate2 = val1;
        }
      }
      if (name == "date25") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate3 = val1;
        }
      }
      if (name == "date26") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate4 = val1;
        }
      }
      if (name == "date27") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.employeesFirstdayEmployment = val1;
        }
      }
      if (name == "date28") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.employerSignDate1 = val1;
        }
      }
      if (name == "date29") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.reverificationDate = val1;
        }
      }
    }
    if (name == "date30") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employmentEligibilityBo.documentExpiryDate = val1;
      }
    }

    // if (name == "date31") {
    //   let val = this.dateservice.Datechange(event);
    //   if (val != undefined) {
    //     let val1 = this.dateservice.Datechange(event);
    //     this.employmentEligibilityBo.employerSignDate3 = val1;
    //   }
    // }

    if (name == "date32") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employeesWithholdingBo.signDate = val1;
      }
    }
    if (name == "date33") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employeesWithholdingBo.firstDateOfEmployeement = val1;
      }
    }
    if (name == "date34") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.w4MinnesotaWithholdingBo.date = val1;
      }
      if (name == "date35") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualSupportWorkerBo.signDate = val1;
        }
      }
      if (name == "date36") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.signDate = val1;
        }
      }
    }
  }

  getEmployeeDetails(data) {
    let params = new URLSearchParams();
    params.append("EmployeeId", data.employeeid)
    if(this.global.OnboardingLoginType !='onboardLogin'){
      this.agreementlistservice
      .getEmployeeBio(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.prepopulatevalue = data;
          
          
         this.prepopulatefun();
        }
      });
    }
  }

  getclientDetails(val) {
    let params = new URLSearchParams();
    params.append("ClientId", val.employerId);
    this.agreementlistservice

      .getClientBio(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.prepopulateClientvalue = data;
         this.prepopulateclientfun();
        }
      });
    }
    prepopulateclientfun() {
      if(this.prepopulateClientvalue){
          this.backgroundBo.participantName = this.prepopulateClientvalue.name;
          this.employmentEligibilityBo.employerFirstName=this.prepopulateClientvalue.firstName
          this.employmentEligibilityBo.employerLastName = this.prepopulateClientvalue.lastName;
          this.employmentEligibilityBo.employersAddress = this.prepopulateClientvalue.street;
          this.employmentEligibilityBo.employersCity = this.prepopulateClientvalue.city;
          this.employmentEligibilityBo.employersState = this.prepopulateClientvalue.state;
          this.employmentEligibilityBo.employersZip = this.prepopulateClientvalue.zipCode;
          // this.employmentEligibilityBo.preparerZip = this.prepopulateClientvalue.zipCode;
          this.w4MinnesotaWithholdingBo.nameofEmployer = this.prepopulateClientvalue.name;
          this.w4MinnesotaWithholdingBo.employerAddress = this.prepopulateClientvalue.street;
          this.w4MinnesotaWithholdingBo.employerCity = this.prepopulateClientvalue.city;
          this.w4MinnesotaWithholdingBo.employerState = this.prepopulateClientvalue.state;
          this.w4MinnesotaWithholdingBo.employerZip = this.prepopulateClientvalue.zipCode;
          this.payNoticeBo.employerName = this.prepopulateClientvalue.name;
          this.relationshipBo.employerName = this.prepopulateClientvalue.name;
        }
      }

      prepopulatefun() {
        if(this.prepopulatevalue!=null&&this.prepopulatevalue!=undefined&&this.prepopulatevalue!=''){
          let db =(this.prepopulatevalue.dob != null &&
            this.prepopulatevalue.dob != undefined &&
            this.prepopulatevalue.dob != "")
              ? this.datepipe.transform(this.prepopulatevalue.dob, "MM/dd/yyyy")
              : null;
          this.backgroundBo.dob = db;
          this.employmentEligibilityBo.dob = db;
          this.individualDirectSupportBo.dob = db;
          this.relationshipBo.dob = db;
    
      
        }
      
        this.employeeApplicationBo.employeeName = this.prepopulatevalue.name;
        
    
        this.backgroundBo.firstName = this.prepopulatevalue.firstName;
        this.backgroundBo.middleName = this.prepopulatevalue.middleName;
        this.backgroundBo.lastName = this.prepopulatevalue.lastName;
        this.backgroundBo.ssn = this.prepopulatevalue.ssn;
        this.backgroundBo.state = this.prepopulatevalue.steet;
        this.backgroundBo.phone = this.prepopulatevalue.phone1;
        this.backgroundBo.state1 = this.prepopulatevalue.steet;
        this.backgroundBo.email = this.prepopulatevalue.email;
        this.backgroundBo.genderLid = this.prepopulatevalue.genderLid;
    
        this.payNoticeBo.employeeName = this.prepopulatevalue.name;
    
    
        this.relationshipBo.employeeName = this.prepopulatevalue.name;
    
        this.individualDirectSupportBo.street = this.prepopulatevalue.street ;
        this.individualDirectSupportBo.nameIndividualSupportWorker =
          this.prepopulatevalue.name;
    
        this.employmentEligibilityBo.reverificationFirstName =      this.prepopulatevalue.firstName;
        this.employmentEligibilityBo.reverificationLastName =      this.prepopulatevalue.lastName;
        this.employmentEligibilityBo.reverificationMiddleName =      this.prepopulatevalue.middleName;
        this.employmentEligibilityBo.firstName = this.prepopulatevalue.firstName;
        this.employmentEligibilityBo.lastName = this.prepopulatevalue.lastName;
        this.employmentEligibilityBo.middleName = this.prepopulatevalue.middleName;
        
    
        this.employmentEligibilityBo.us_Ssn = this.prepopulatevalue.ssn;
        this.employmentEligibilityBo.employees_Email = this.prepopulatevalue.email;
        this.employmentEligibilityBo.employeesPhone = this.prepopulatevalue.phone1;
        this.employmentEligibilityBo.employeeSection2LastName = this.prepopulatevalue.lastName;
        this.employmentEligibilityBo.employeeSection2FirstName = this.prepopulatevalue.firstName;
        this.employmentEligibilityBo.employeeSection2MiddleName = this.prepopulatevalue.middleName;
      //  this.employeesWithholdingBo.maritialStatus = this.prepopulatevalue.maritialStatus;
        this.employeesWithholdingBo.firstName = this.prepopulatevalue.firstName;
        this.employeesWithholdingBo.maritialStatus =  this.employeesWithholdingBo.maritialStatus;
        this.employeesWithholdingBo.lastName = this.prepopulatevalue.lastName;
        this.employeesWithholdingBo.middleName = this.prepopulatevalue.middleName;
        this.employeesWithholdingBo.social_Security_Number =
          this.prepopulatevalue.ssn;
        this.employeesWithholdingBo.employeeName = this.prepopulatevalue.name;
        this.employeesWithholdingBo.address = this.prepopulatevalue.street;
        this.employeesWithholdingBo.state = this.prepopulatevalue.steet;
    
        this.w4MinnesotaWithholdingBo.firstName  = this.prepopulatevalue.firstName + (( this.prepopulatevalue.middleName != null && this.prepopulatevalue.middleName != undefined ) ? this.prepopulatevalue.middleName : '' );
        this.w4MinnesotaWithholdingBo.lastName = this.prepopulatevalue.lastName;
        this.w4MinnesotaWithholdingBo.middleInitial =
          this.prepopulatevalue.middleName;
        this.w4MinnesotaWithholdingBo.socialSecurityNumber =
          this.prepopulatevalue.ssn;
        this.w4MinnesotaWithholdingBo.state = this.prepopulatevalue.steet;
    
        this.backgroundBo.zip = this.prepopulatevalue.zipcode;
        this.backgroundBo.address = this.prepopulatevalue.street;
        this.backgroundBo.city = this.prepopulatevalue.city;
        this.backgroundBo.county = this.prepopulatevalue.county;
    
        this.employmentEligibilityBo.address = this.prepopulatevalue.street;
        this.employmentEligibilityBo.apt = this.prepopulatevalue.apt;
        this.employmentEligibilityBo.city = this.prepopulatevalue.city;
        this.employmentEligibilityBo.state = this.prepopulatevalue.steet;
        // this.employmentEligibilityBo.zip = this.prepopulatevalue.zipcode;
    
        this.employeesWithholdingBo.city = this.prepopulatevalue.city;
        this.employeesWithholdingBo.zip = this.prepopulatevalue.zipcode;
    
        this.w4MinnesotaWithholdingBo.address = this.prepopulatevalue.street;
        this.w4MinnesotaWithholdingBo.city = this.prepopulatevalue.city;
        this.w4MinnesotaWithholdingBo.zip = this.prepopulatevalue.zipcode;
    
        this.individualSupportWorkerBo.umpi = this.prepopulatevalue.umpi;
        this.individualSupportWorkerBo.nameofSupportWorkerName =
          this.prepopulatevalue.name;
        //  this.individualSupportWorkerBo.directSupportWorkerInitial = this.prepopulatevalue.directSupportWorkerInitial;
      
        this.individualSupportWorkerBo.nameofSupportWorkerNamePrint =
          this.prepopulatevalue.name;
    
        this.individualDirectSupportBo.ssn = this.prepopulatevalue.ssn;
        this.individualDirectSupportBo.npiOrUmpi = this.prepopulatevalue.umpi;
        this.individualDirectSupportBo.firstName = this.prepopulatevalue.firstName;
        this.individualDirectSupportBo.lastName = this.prepopulatevalue.lastName;
        this.individualDirectSupportBo.middleName =
          this.prepopulatevalue.middleName;
        this.individualDirectSupportBo.phone = this.prepopulatevalue.phone1;
        this.individualDirectSupportBo.county = this.prepopulatevalue.county;
        this.individualDirectSupportBo.zip = this.prepopulatevalue.zipcode;
        this.individualDirectSupportBo.state = this.prepopulatevalue.steet;
        this.individualDirectSupportBo.city = this.prepopulatevalue.city;
      }
  strigToBooleanRadio(){}
  checkssn(){}
  supportname(){}
  DemographicPhoneFormat(){}
  IDSWFormRadio1(){} 
  IDSWFormRadio2(){}
  IDSWFormRadio3(){}
  suptwrkName(){}
  validZip(){}
  one_bool($event){}
  checkValue_single1(val) {}
  w4_fun_marriedheld(val) {}
  clickone(val) {}
  sectionDetermine(a){}
  option_section2(a){}
  hire(a){}


  relationdisclosureBo: RelationshipDisclosureTaxDetailBO[] = [];
  relationShipTaxName:any;
  GetEmployeeClientRelationshipList(data) {
    let params = new URLSearchParams();
    params.append("EmployeeId",data.employeeid );
    params.append("ClientId",data.employerId );
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementemitservice
      .GetEmployeeClientRelationshipData(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          let getadta=JSON.parse(JSON.stringify(data));      
          this.reationshipname=data.relationshipName
          this.relationshipBo.relationshipName=this.reationshipname;
          this.relationShipTaxName = data.relationshipTaxes;
          
          this.relationShipTaxName.forEach((element) => {
            if(element.taxable == true ) {
             element.taxable='Taxable';
            }
            else{
             element.taxable='Exempt';
            }
           });
          
          // this.relationdisclosureBo=this.reationshiplist
let obj=new RelationshipDisclosureTaxDetailBO()
obj=this.relationshiplist
if(this.relationshiplist!=undefined && this.relationshiplist!=null){
this.relationshiplist.forEach((ele)=>{
  obj=new RelationshipDisclosureTaxDetailBO()

  obj.relationshipDisclosureId=data.relationshipId
  obj.taxName=ele.taxName
  obj.taxable=ele.taxable
  this.relationdisclosureBo.push(obj)
  
})        } 
        }
      });
  }else{
    this.getEmployeeDetails(data)
    this.agreementemitservice
      .GetEmployeeClientRelationshipDataPortal()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        
          this.relationshiplist = data.relationshipTaxes;
          this.relationShipTaxName = data.relationshipTaxes;
          this.relationShipTaxName.forEach((element) => {
            if(element.taxable == true ) {
             element.taxable='Taxable';
            }
            else{
             element.taxable='Exempt';
            }
           });
       
          this.reationshipname=data.relationshipName;
          this.relationshipBo.relationshipName=this.reationshipname;

      })
  }
}

abc(){
  
}

// ngAfterContentChecked() {
//   this.cdr.detectChanges();

  
// }


DeleteAgreement(data) {
  this.AggrementDeleteId=data.id;
}

Delete() {
  let param = new URLSearchParams()
  param.append("AggrementId", this.AggrementDeleteId)
  this.agreementlistservice .DeleteEMpAggrementInfo(param).subscribe((data: any) => {
    this.toastService.success("Employee Aggrement Deleted successfully!");
    document.getElementById("openEmployeeAggrdelete").click();
   this.getagreementGridData();
  },
    (err: any) => {
      if (err) {
        this.toastService.error(err, 'Error'), 8000;
      }
    })
}

}

